
 import { Entity } from '../common/base/entity/entity'
import { tabsMeta } from '../common/base/entity/schemas'
import { EmailSettingAction } from '../emailSettings/EmailAction'
import { methodSchemas, collectionSchemas, entitySchema } from './email.schema'
 

class emailSetting extends Entity {
  // override the following if needed.
  // derived actionObj
  // derived Service obj
  // getActionFns if you want to suppress the baseActionobj methods
}


const fieldsMeta = {
    name: {
        label: 'Name',
        required: true,
        type: 'text',
        name: 'name',
        readOnlyOnEdit: true
    },
    configType: {
        label: 'Config Type',
        required: true,
        type: 'text',
        name: 'configType',
        readOnlyOnEdit: true
    },
    appModule: {
        label: 'App Module',
        required: true,
        type: 'text',
        name: 'appModule',
        readOnlyOnEdit: true
    },
    supportEmail: {
        label: 'From Email',
        required: true,
        type: 'text',
        name: 'supportEmail',
        // default: 'system@rezolve.ai',
        placeholder: 'Default From Email is system@rezolve.ai',
        regexPattern:
        '^(([^<>()[\\]\\.,;:\\s@\\"]+(.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
        error: 'Email Id is not valid',
    },
    replyTo:{
        label: 'Reply To',
        required: true,
        type: 'text',
        name: 'replyTo',
        // readOnlyOnEdit: false,
        // readOnly: true,
        disabled: true
    },
    status: {
        label: "Status",
        name: 'status',
        options: [{label: 'Published', value: 'Published'}, {label: 'Deleted', value: 'Deleted'}],
        type: 'select',
        required: true
    }
    
}

const actionsMeta = {
    editItem: {
        type: 'button',
        label: 'Edit',
        action: 'editItem',
        name: 'editItem'
    },
    cancel: {
        type: 'button',
        label: 'Cancel',
        action: 'cancelEdit',
        name: 'cancel'
    },
    upsert: {
        label: 'Update',
        name: 'update',
        action: 'publishItem',
        classes: 'fa fa-pencil fa-lg ',
        type: 'span'
    },   
    update: {
        label: 'Edit',
        name: 'update',
        action: 'updateItem',
        classes: 'fa fa-pencil fa-lg ',
        type: 'span'
    },
    list: {
        label: 'List All',
        name: 'list',
        action: 'load'
    },
    search: {
        label: 'Search',
        name: 'search',
        action: 'search'
    },
    view: {
        label: 'View',
        name: 'view',
        action: 'getItem',
        classes: 'fa fa-eye fa-lg',
        type: 'span'
    }
}
const sectionsMeta = {
    basic: {
        title: 'EmailSignature Details',
        items:[
        {"name":"supportEmail", type: "field" },{"name":"replyTo", type: "field" }],
        classes:"ticket-form"
    },

    headerComponent: {
        component: 'DetailHeader',
    },
    
    emailSettingsView: {
        cols: [7,5],
        items:[{name: 'basic', type: 'section', col: 1}, 
        {name: 'upsert', type: 'action', col: 1},
        ],
        classes: 'composite-inner-form'
    }
}

const screens = {
    view: {
        items: [{name:'headerComponent', type: 'section'}, {name: 'emailSettingsView', type: 'section'}],
        title: 'Email Settings',
    },
    // create:{
    //     items: [{name:'headerComponent', type: 'section'}, {name: 'emailTemplatesCreateForm', type: 'section'}]
    // },
    edit:{
        items: [{name:'headerComponent', type: 'section'}, {name: 'emailSettingsView', type: 'section'}]
    },
    list: {
        items: [{"name":"name", type: "link"}, {"name":"status", type: "field"}],
        filter : [{
            name: "status",
            operator: "ne",
            value: "Deleted"
        },{
            name: "name",
            operator: "eq",
            value: "emailSettings"
        }],
        orderBy:['createdAt desc'],
        multiselect:false,
    }
}
 

const emailSettingContainer = new emailSetting({ActionClass: EmailSettingAction, fieldsMeta, actionsMeta, sectionsMeta, tabsMeta:{}, screens, name: 'EmailSetting', title: 'Email Settings', methodSchemas, collectionSchemas,  entitySchema, idKey: 'id', entityUrlPaths:{update: `ticketing/TenantConfig/update`,  default: `ticketing/TenantConfig`, publish:`ticketing/TenantConfig/publish`, getOne:`ticketing/TenantConfig/findWithDefaultTenant`, getAll: `ticketing/TenantConfig/findWithDefaultTenant`}, fetchDetailByApi: false })

const emailSettingListSearchContainer = emailSettingContainer.getContainer('ListSearch')
const emailSettingDetailContainer = emailSettingContainer.getContainer('Detail')
export { emailSettingDetailContainer ,emailSettingListSearchContainer }

 